import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { createPortal } from 'react-dom';
import { Overlay } from 'components';
import cuid from 'cuid';
import i24 from 'assets/images/i24.svg';
import { withTranslated } from 'components/HOC';

const propTypes = {
  children: PropTypes.any.isRequired,
};

type State = {
  top: ?number,
  right: ?number
};

class TripleDotBtn extends React.Component<any, State> {
  constructor() {
    super();
    this.id = cuid();
    this.node = null;
    this.hook = document.getElementById('overlay');
    this.html = document.documentElement;
    this.actions.open = this.actions.open.bind(this);
    this.actions.close = this.actions.close.bind(this);
  }

  componentDidMount() {
    this.node = document.getElementById(this.id);
  }

  state = { top: null, right: null };

  actions = {
    open(): void {
      const rect = this.node.getBoundingClientRect();
      this.setState({ top: rect.top + this.html.scrollTop, right: this.html.clientWidth - rect.right });
    },
    close(): void {
      this.setState({ top: null, right: null });
    }
  }

  renderChildren = () => {
    const { children } = this.props;
    if(typeof children === 'function') return children({ close: this.actions.close });
    return React.Children.map(children, (child) => (
      <div onClick={this.actions.close}>
        {child}
      </div>
    ));
  }

  render() {
    const { top, right } = this.state;
    const { t } = this.props;
    const visibilityStyle = top ? {visibility: 'visible'} : undefined;

    let styles = {};
    if(top) {
      styles = { display: 'block', top: top + 30, right, zIndex: 3, position: 'absolute' };
    }
    
    return (
      <Fragment>
        <div className="more-options" id={this.id} onClick={this.actions.open} style={visibilityStyle}>
          <img src={i24} alt={t("opcje")} />
        </div>
        {top !== null && createPortal(
          <Overlay close={this.actions.close}>
            <div className="options-list" style={styles}>{this.renderChildren()}</div>
          </Overlay>
        , this.hook)}
      </Fragment>
    );
  }
}

TripleDotBtn.propTypes = propTypes;
export default withTranslated(TripleDotBtn);


// WEBPACK FOOTER //
// ./src/components/ui/TripleDotBtn.jsx